import { useState, useEffect } from "react";
import moment from "moment-timezone";
import { fetchWrapper } from "src/helpers";

export interface Holiday {
  date: string;
  holidayName: string;
}
export const useNonWorkingDays = (upto?: "lastSourceDate") => {
  const [nonWorkingDays, setNonWorkingDays] = useState<Date[]>([]);

  useEffect(() => {
    const fetchNonWorkingDays = async () => {
      try {
        const query = upto ? `?upto=${upto}` : "";
        const response: Holiday[] = await fetchWrapper.get(
          `/api/dashboard/non-working-days${query}`,
        );
        if (Array.isArray(response)) {
          const dates = response.map((h) =>
            moment.tz(h.date, "Asia/Kolkata").toDate(),
          );
          setNonWorkingDays(dates);
        }
      } catch (error) {
        console.error("Failed to fetch non-working days", error);
      }
    };
    fetchNonWorkingDays();
  }, [upto]);

  return nonWorkingDays;
};
